module.exports = __webpack_public_path__ + "static/media/left-arrow.16616fad.svg";